import type { AiAppCenterModule } from '../types'

/**
 * AI 超级小秘书（system_module.name=aiSecretary）
 * 菜单物理根：/ai-secretary（F14）
 */
export const aiSecretaryModule: AiAppCenterModule = {
  key: 'aiSecretary',
  label: 'AI超级小秘书',
  desc: '数字员工 / 智能体 / 工作流 / 岗位与团队',
  path: '/ai-secretary',
  homePath: '/ai-secretary/employee',
  menuPaths: ['/ai-secretary'],
  icon: 'ep:avatar',
  color: '#0d9488',
  aliases: ['AI 超级小秘书', '超级小秘书', 'AI数字员工', 'AI 数字员工'],
  // 技能/提示词/智能体/工作流/执行团队在员工表单或其它入口配置，独立窗侧栏不单独暴露
  hiddenStandaloneMenuTitles: ['AI 提示词', 'AI 技能', 'AI 智能体', 'AI 工作流', 'AI 执行团队']
}
